import React from "react";
import { Modal, Button, Row, Col, Badge } from "react-bootstrap";
import { getGalleryImagesForFolder } from "../../utils/imageLoader";
import "./ProjectDetailsModal.css";
import NoImage from "../../assets/images/no-image.png";

let imageUrl = "https://www.centillionsoftechhrm.com/api/v1/resources/portfolio/";
const ProjectDetailsModal = ({ show, onHide, project }) => {
  const [zoomedImage, setZoomedImage] = React.useState(null);

  if (!project) return null;

  const {
    projectName,
    localImageSrc,
    shortDescription,
    longDescription,
    technology = [],
    otherPhotos = [],
    Section,
    link
  } = project;

  // If imageFolderName is provided, try to load images from that folder
  // const dynamicGallery = imageFolderName ? getGalleryImagesForFolder(imageFolderName) : [];
  // const finalGallery = dynamicGallery.length > 0 ? dynamicGallery : gallery;

  const handleImageClick = (imgSrc) => {
    setZoomedImage(imgSrc);
  };

  const closeZoom = () => {
    setZoomedImage(null);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        centered
        className="project-details-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-primary">
            {projectName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="project-banner" onClick={() => handleImageClick( localImageSrc ?  localImageSrc : NoImage)} style={{ cursor: 'zoom-in' }}>
            <img
           src={localImageSrc? localImageSrc : NoImage}
              alt={projectName}
              className="img-fluid w-100 main-project-img"
            />
            <div className="project-overlay-type">
              <Badge bg="primary">{Section}</Badge>
            </div>
            <div className="zoom-hint">
               <i className="fa fa-search-plus"></i> Click to Zoom
            </div>
          </div>

          <div className="p-4">
            <section className="mb-4">
              <h5 className="fw-bold mb-3 border-bottom pb-2">About Project</h5>
              {longDescription && (
                <div className="long-description mt-3" style={{ whiteSpace: 'pre-line' }}>
                  {longDescription.split(/[#\n]+/).map((para, index) => (
                    para.trim() && <p key={index} className={para.includes(':') || para.toUpperCase() === para ? 'fw-bold mt-3' : ''}>{para.trim()}</p>
                  ))}
                </div>
              )}
            </section>

            <section className="mb-4">
              <h5 className="fw-bold mb-3 border-bottom pb-2">Technologies Used</h5>
              <div className="d-flex flex-wrap gap-2">
                {technology.map((tech, index) => (
                  <Badge key={index} pill bg="light" text="dark" className="border px-3 py-2 tech-badge">
                    {tech}
                  </Badge>
                ))}
              </div>
            </section>

            {otherPhotos && otherPhotos.length > 0 && (
              <section className="mb-4">
                <h5 className="fw-bold mb-3 border-bottom pb-2">Project Gallery</h5>
                <Row className="g-3">
                  {otherPhotos.map((img, index) => (
                    <Col xs={6} md={4} key={index}>
                      <div 
                        className="gallery-item shadow-sm rounded overflow-hidden" 
                        onClick={() => handleImageClick(img)}
                        style={{ cursor: 'zoom-in' }}
                      >
                        <img
                         src={img ? imageUrl + img : NoImage}
                          alt={`${projectName} - ${index}`}
                          className="img-fluid gallery-img"
                        />
                        <div className="gallery-item-overlay">
                           <i className="fa fa-search-plus"></i>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </section>
            )}

            {link && link !="" && (
              <div className="d-grid mt-4">
                <Button 
                  variant="outline-primary" 
                  href={link} 
                  target="_blank"
                  className="py-2 fw-bold"
                >
                  View Live Project / Report
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Zoom Modal - Lightbox Effect */}
      <Modal
        show={!!zoomedImage}
        onHide={closeZoom}
        centered
        size="xl"
        className="image-zoom-modal"
        contentClassName="bg-transparent border-0"
      >
        <Modal.Header closeButton closeVariant="white" className="border-0 pb-0">
        </Modal.Header>
        <Modal.Body className="p-0 d-flex justify-content-center align-items-center" onClick={closeZoom}>
          <img 
            src={zoomedImage} 
            alt="Zoomed Project View" 
            className="img-fluid rounded-3 zoomed-image"
            style={{ maxHeight: '90vh', width: 'auto', outline: 'none' }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProjectDetailsModal;
